import firebase from "../../firebase"

const db = firebase.firestore().collection("/questions")

export default {
    getAll() {
        return db;
    }
}